// extracted by mini-css-extract-plugin
module.exports = {"expand":"Expand_expand__2WmVq","expandButton":"Expand_expandButton__395na","title":"Expand_title__SvJJt","content":"Expand_content__136Dx"};